<ng-container *ngIf="ready">
  <div class="container-fluid mb-3">
    <div class="row">
      <div class="col-4">
        <p><strong>Partner</strong></p>
      </div>
      <div class="col-8">
        <button mat-stroked-button class="pull-right" (click)="closeDialog()">
          Cerrar
        </button>
        <button mat-stroked-button class="btn-convfact me-3 pull-right" (click)="onSubmit()">
          <mat-icon>save</mat-icon>
          Guardar
        </button>
      </div>
    </div>


    <div class="row">
      <div class="col-lg-3 col-xs-12">
        <app-input inputType="text" placeholder="Name" name="model.name" [(ngModel)]="model.name"
          [disabled]="initial"></app-input>
      </div>
      <div class="col-lg-3 col-xs-12">
        <app-input inputType="text" placeholder="NIF" name="model.vatNumber" [(ngModel)]="model.vatNumber"
          [disabled]="initial"></app-input>
      </div>
      <div class="col-lg-3 col-xs-12">
        <app-autocomplete-select [items]="provinces" [(selectedItemId)]="model.provinceCode" [idField]="'provinceCode'"
          [displayField]="'provinceName'" placeholder="Provincia" (selectionChanged)="onProvinceChanged($event)"
          [isRequired]="true">
        </app-autocomplete-select>
      </div>
      <div class="col-lg-3 col-xs-12">
        <app-autocomplete-select [items]="municipalities" [(selectedItemId)]="model.municipalityCode"
          [idField]="'municipalityCode'" [displayField]="'municipalityName'" placeholder="Municipio">
        </app-autocomplete-select>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="!ready">
  <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
</ng-container>